import { ProductUseType } from 'constants/enums';
import { POS_USE_TYPE_OPTIONS } from 'constants/options';
import { getLocationUseTypes } from 'utils/storageUtils';

export const NEW_CUSTOMER_DEFAULT_VALUES = {
  firstName: '',
  lastName: '',
  customerName: '',
  phone: '+1', // allow user to only add the phone number, without the country code
  email: '',
  dateOfBirth: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  zip: '',
  driversLicense: '',
  driversLicenseSt: '',
  driverLicenseExpires: '',
  expirationDate: undefined,
  patientNumber: '',
  type: ProductUseType.is_adult_use,
};

export const getPosUseTypes = () => {
  const { adultUse, medicalUse } = getLocationUseTypes();
  const result = [];

  if (adultUse) {
    const value = POS_USE_TYPE_OPTIONS.find((option) => option.key === ProductUseType.is_adult_use);

    if (value) {
      result.push(value);
    }
  }

  if (medicalUse) {
    const value = POS_USE_TYPE_OPTIONS.find((option) => option.key === ProductUseType.is_medical_use);

    if (value) {
      result.push(value);
    }
  }

  return result.filter(Boolean);
};
